import React, { useState } from "react";
import Typography from "components/Typography";
import { TextField, Switch } from "components/Fields";
import InheritedValueIcon from "../InheritedValueIcon";

const WaterUtility =  ({ propertyDetails, tenancyDetails, updateTenancyContract }) => {

	const isLandlordResponsible = tenancyDetails.utilities?.water?.isLandlordResponsible ?? propertyDetails.utilities?.water?.isLandlordResponsible;
	const isLandlordReponsibleInherited = tenancyDetails.utilities?.water?.isLandlordResponsible == null || tenancyDetails.utilities?.water?.isLandlordResponsible == undefined;

	const hasIndividualMeters = tenancyDetails.utilities?.water?.hasIndividualMeters ?? propertyDetails.utilities?.water?.hasIndividualMeters;
	const isHasIndividualMetersInherited = tenancyDetails.utilities?.water?.hasIndividualMeters == null || tenancyDetails.utilities?.water?.hasIndividualMeters == undefined;

	const accountingStartDateInitialValue = tenancyDetails.utilities?.water?.accountingStartDate ?? propertyDetails.utilities?.water?.accountingStartDate ?? "";
	const isAccountingStartDateInherited = !tenancyDetails.utilities?.water?.accountingStartDate;
	const [accountingStartDate, setAccountingStartDate] = useState(accountingStartDateInitialValue);

    return (
        <>
            <Typography variant="label" className="utility-title">Vand</Typography>
            <div className="fields-section__container">
                <div className="fields-section__field">
                    <Typography variant="label">Udlejer ansvarlig {isLandlordReponsibleInherited && <InheritedValueIcon />}</Typography>
                    <Switch
                        checked={isLandlordResponsible}
                        onChange={(e) => updateTenancyContract({ utilities: { water: { isLandlordResponsible: e.target.checked } } })}
                    />
                </div>
				<div className="fields-section__field">
                    <Typography variant="label">Lejemålet har individuelle målere {isHasIndividualMetersInherited && <InheritedValueIcon />}</Typography>
                    <Switch
                        checked={hasIndividualMeters}
                        onChange={(e) => updateTenancyContract({ utilities: { water: { hasIndividualMeters: e.target.checked } } })}
                    />
                </div>
                <div className="fields-section__field">
                    <Typography variant="label">Vandregnskabsåret begynder {isAccountingStartDateInherited && <InheritedValueIcon />}</Typography>
					<TextField
						value={accountingStartDate ?? ""}
						type="date"
						onChange={(event) => setAccountingStartDate(event.target.value)}
						onExit={() => setAccountingStartDate(accountingStartDateInitialValue)}
						onFinish={() => {
							accountingStartDate !== accountingStartDateInitialValue && updateTenancyContract({ utilities: { water: { accountingStartDate } } })
						}}
					/>
                </div>
            </div>
            <hr/>
        </>
    );
};

export default WaterUtility;